(function () {
  var instances = {};

  function destroySwiper(sectionId) {
    var inst = instances[sectionId];
    if (inst && typeof inst.destroy === 'function') inst.destroy(true, true);
    delete instances[sectionId];
  }

  function initSwiper(sectionId) {
    if (instances[sectionId]) return;
    var el = document.getElementById('ps-swiper-' + sectionId);
    if (!el) return;

    if (typeof window.Swiper === 'undefined') {
      setTimeout(function () { initSwiper(sectionId); }, 50);
      return;
    }

    instances[sectionId] = new Swiper(el, {
      slidesPerView: 1.199,
      spaceBetween: 22,
      centeredSlides: false,
      loop: true,
      speed: 500,
      autoplay: false,
      navigation: {
        nextEl: document.getElementById('ps-next-' + sectionId),
        prevEl: null
      },
      breakpoints: {
        400: { slidesPerView: 1.4, spaceBetween: 16 },
        480: { slidesPerView: 2.3, spaceBetween: 16 },
        769: { slidesPerView: 3.3, spaceBetween: 20 },
        1025: { slidesPerView: 4.2, spaceBetween: 20 },
        1280: { slidesPerView: 4.28, spaceBetween: 22 }
      }
    });
  }

  function initAll() {
    document.querySelectorAll('.product-slider[data-section-id]').forEach(function (el) {
      initSwiper(el.dataset.sectionId);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:unload', function (e) {
    if (e.detail) destroySwiper(e.detail.sectionId);
  });

  document.addEventListener('shopify:section:load', function (e) {
    if (e.detail) {
      destroySwiper(e.detail.sectionId);
      initSwiper(e.detail.sectionId);
    }
  });
})();
